import { render, staticRenderFns } from "./hidePage.vue?vue&type=template&id=4da15e5e&scoped=true&"
import script from "./hidePage.vue?vue&type=script&lang=js&"
export * from "./hidePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da15e5e",
  null
  
)

export default component.exports